import { SessionType } from '@core/types';

export const ANONYMOUS: SessionType = null;
export const CACHE_SIZE: number = 1;
export const FILTER_ONLY_NUMBERS: RegExp = /[^0-9]/g;
export const FILTER_E_FROM_NUMERIC_INPUT: RegExp = /[eE]/g;
export const FILTER_ONLY_NUMBERS_WITH_DOT: RegExp = /[^0-9.]/g;
export const FILTER_CIC_NUMBERS: RegExp = /^[0-9]{6,10}$/;
export const FILTER_ARC_NUMBERS: RegExp = /^050[0-9]{7}$/;
export const FILTER_OTP_NUMBERS: RegExp = /^[0-9]{6}$/;
export const FILTER_YEAR_NUMBERS: RegExp = /^[1-2]{1}[0-9]{3}$/;
export const FILTER_NUMBERS_WITH_DECIMALS: RegExp = /^[0-9]*[.]{0,1}[0-9]*$/;
export const FILTER_TEXT_FOR_TEXTAREA: RegExp = /^[a-zA-Z0-9,_. ]*$/;
export const FILTER_ONLY_NUMBERS_STRING: string = '[0-9]*';

export const ITEMS_PER_PAGE = 50;

export const PROJECTS = {
  PROVIDERS: 'providers',
  BENEFICIARIES: 'portal',
  REGISTRY: 'registry',
};
